module.exports = __webpack_public_path__ + "img/company-settings.bebb5122.svg";